import createDependentCollector from "./utils/create-dependent-collector";

const getForConferenceSelectionV2 = createDependentCollector(["ConferenceRankV2"]);

export default getForConferenceSelectionV2;
